module.exports = __webpack_public_path__ + "img/visible.a4dfeb0f.svg";